import { colors as MuiColors } from '@mui/material';

export const colors = {
  branco: '#FFFFFF',
  branco10: '#f6f6f6',

  cinza: '#7e7e7e',
  cinza10: '#cccccc',
  cinza20: '#808080',
  cinza30: '#a1a1a1',

  verde: '#136033',
  verde05: '#145f35',
  verde10: '#23c265',
  verde20: '#00C000',
  verde30: '#86b89b',
  verde40: '#e0ffed',

  preto: '#000000',
  preto2: '#161616E6',

  vermelho: '#e91e1e',

  azul: '#3375CC',
};

export const colorConfigs = {
  sidebar: {
    bg: '#136033',
    color: '#ffffff',
    hoverBg: '#23c265',
    activeBg: '#23c265',
  },
  topbar: {
    bg: '#fff',
    color: '#000',
  },
  mainBg: MuiColors.grey['100'],
};
